import React from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import {
  ListItemButton,
  type ListItemButtonProps,
} from '@wix/da-ds/pkg/List/ListItem';
import GallectionCover from '../GallectionCover';

interface Props
  extends Omit<ListItemButtonProps, 'label' | 'prefix' | 'fillContainerWidth'> {
  gallection: PapiGallection;
}

const GallectionListItemButton: React.FC<Props> = ({ gallection, ...rest }) => {
  return (
    <ListItemButton
      label={gallection.name}
      prefix={<GallectionCover gallection={gallection} />}
      fillContainerWidth
      {...rest}
    />
  );
};

GallectionListItemButton.displayName = 'GallectionListItemButton';

export default GallectionListItemButton;
